const models = [{
  id: 'snow-star',
  name: 'Snow Star',
  name_extension: '',
  price_from: 'CHF 1,790',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/snow-star_silver-sky.jpg?v=1618390579',
  colors: [{
    id: 'ice-blue',
    name_pre: 'Ice',
    name: 'Blue',
    name_post: '',
    price_from: 'CHF 1,790',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/snow-star_ice-blue.jpg?v=1618390579',
    variantId: 37179246149789,
    strapOptions: {
      'blue-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/blue.jpg?v=1620317528',
      'black-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/black.jpg?v=1620317528',
      'khaki-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/khaki.jpg?v=1620317528',
      'brown-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-brown.jpg?v=1620317528',
      'black-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-black.jpg?v=1620317528',
      'beige-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-beige.jpg?v=1620317528',
      'grey-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-grey.jpg?v=1620317528',
      'blue-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-blue.jpg?v=1620317528',
      'black-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-black.jpg?v=1620317528',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/snow_star-blue-mesh.jpg?v=1626852251',
      'nato-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame78_1800x1800.png?v=1657291680',
      'nato-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame82_1800x1800.png?v=1657292108'
    }
  }, {
    id: 'boreal-green',
    name_pre: 'Boreal',
    name: 'Green',
    name_post: '',
    price_from: 'CHF 1,790',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/snow_star-boreal_green.jpg?v=1654622243',
    variantId: 42923742298335,
    strapOptions: {
      'blue-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-blue_textile.jpg?v=1654623267',
      'black-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-black_textile.jpg?v=1654623267',
      'khaki-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-khaki_textile.jpg?v=1654623267',
      'brown-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-brown_leather.jpg?v=1654623267',
      'black-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-black_leather.jpg?v=1654623267',
      'beige-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-beige_leather.jpg?v=1654623267',
      'grey-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-grey_leather.jpg?v=1654623267',
      'blue-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-blue_rubber.jpg?v=1654623267',
      'black-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-black_rubber.jpg?v=1654623267',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/boreal_green-mesh.jpg?v=1654623267',
      'nato-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame79_1800x1800.png?v=1657291680',
      'nato-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame83_1800x1800.png?v=1657292107'
    }
  }, {
    id: 'night-black',
    name_pre: 'Night',
    name: 'Black',
    name_post: '',
    price_from: 'CHF 1,790',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/snow-star_night-black.jpg?v=1618390579',
    variantId: 31629277200516,
    strapOptions: {
      'blue-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/blue_eb224f9d-d897-4c7c-8fa8-55c616a01624.jpg?v=1620317766',
      'black-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/black_ec2e786e-660c-4344-95ce-3a08da570ef1.jpg?v=1620317766',
      'khaki-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/khaki_d44eff99-d71f-4826-afb9-0a86c3cb1431.jpg?v=1620317766',
      'brown-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-brown_a16c5bed-4e7b-4451-b314-2c88739acc6e.jpg?v=1620317766',
      'black-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-black_9c20a2a6-e276-42ad-8816-1f1a5f1b00d3.jpg?v=1620317766',
      'beige-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-beige_aac852b5-4d23-4c3e-bad5-f0878f50d770.jpg?v=1620317766',
      'grey-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-grey_a7d603f9-1358-4a80-8f9e-31b06d52f317.jpg?v=1620317766',
      'blue-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-blue_05da744d-eac5-4b20-962b-a91878f7ebe3.jpg?v=1620317766',
      'black-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-black_d8bdf5f1-d27a-4fee-9f2d-5e1d6e1bd7bf.jpg?v=1620317766',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/snow_star-black-mesh.jpg?v=1626852251',
      'nato-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame76_1800x1800.png?v=1657291680',
      'nato-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame81_1800x1800.png?v=1657292108'
    }
  }, {
    id: 'sky-silver',
    name_pre: 'Sky',
    name: 'Silver',
    name_post: '',
    price_from: 'CHF 1,790',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/snow-star_silver-sky.jpg?v=1618390579',
    variantId: 31870625611908,
    strapOptions: {
      'blue-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/blue_b7e7738f-16c4-43d9-bc0b-ba67a1f34f73.jpg?v=1620318015',
      'black-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/black_49963fe8-c461-4ab6-86e2-6893a2026f6a.jpg?v=1620318015',
      'khaki-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/khaki_9402559d-96fd-43dc-96da-0b8eae3c8f9f.jpg?v=1620318015',
      'brown-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-brown_b902b16e-19f1-4260-a7d9-c67f7bdb0e78.jpg?v=1620318016',
      'black-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-black_1b5076b4-95d9-41dc-a156-ed23118fef39.jpg?v=1620318016',
      'beige-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-beige_6580a792-f793-473c-b26d-18c6eec7da1a.jpg?v=1620318015',
      'grey-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-grey_d79de759-af5b-467f-84a7-8cdad4bd0c8f.jpg?v=1620318016',
      'blue-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-blue_4d313e6c-e2cc-4759-b046-47bef707065d.jpg?v=1620318016',
      'black-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-black_53b01950-0898-4b28-b218-15e902332342.jpg?v=1620318016',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/snow_star-silver-mesh.jpg?v=1626852251',
      'nato-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame77_1800x1800.png?v=1657291680',
      'nato-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame80_1800x1800.png?v=1657292108'
    }
  }]
}, {
  id: 'lab-01',
  name: 'Lab 01',
  name_extension: '',
  price_from: 'CHF 1090',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_concrete-grey.jpg?v=1618390526',
  colors: [{
    id: 'sky-blue',
    name_pre: 'Sky',
    name: 'Blue',
    name_post: '',
    price_from: 'CHF 1090',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_sky-blue.jpg?v=1618390527',
    variantId: 31630597947524,
    strapOptions: {
      'lab-01-grey': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_sky-blue_blue.jpg?v=1620426677',
      'lab-01-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_sky-blue_black.jpg?v=1620426677',
      'lab-01-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_sky-blue_grey.jpg?v=1620426677',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab_01-blue-mesh.jpg?v=1626852697'
    }
  }, {
    id: 'concrete-grey',
    name_pre: 'Concrete',
    name: 'Grey',
    name_post: '',
    price_from: 'CHF 1090',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_concrete-grey.jpg?v=1618390526',
    variantId: 31629474857092,
    strapOptions: {
      'lab-01-grey': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_concrete-grey_blue.jpg?v=1620426677',
      'lab-01-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_concrete-grey_black.jpg?v=1620426677',
      'lab-01-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_concrete-grey_grey.jpg?v=1620426677',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab_01-white-mesh.jpg?v=1626852697'
    }
  }, {
    id: 'street-black',
    name_pre: 'Street',
    name: 'Black',
    name_post: '',
    price_from: 'CHF 1090',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_street-black.jpg?v=1618390526',
    variantId: 31630510686340,
    strapOptions: {
      'lab-01-grey': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_street-black_blue.jpg?v=1620426677',
      'lab-01-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_street-black_black.jpg?v=1620426677',
      'lab-01-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab-01_street-black_grey.jpg?v=1620426677',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/lab_01-grey-mesh.jpg?v=1626852697'
    }
  }]
}, {
  id: 'archimedes',
  name: 'Archimèdes',
  name_extension: 'by Milus',
  price_from: 'CHF 2,019',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_silver-storm.jpg?v=1618390430',
  colors: [{
    id: 'wild-green',
    name_pre: 'Wild',
    name: 'Green',
    name_post: '',
    price_from: 'CHF 2,019',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_wild-green.jpg?v=1618390430',
    variantId: 36599509975197,
    strapOptions: {
      'blue-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/blue_f8af95f3-79d7-41b0-b8d7-9f299d92c78c.jpg?v=1620318490',
      'black-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/black_f72ab1c6-3bdf-47a0-aac0-5446c2ba57ad.jpg?v=1620318490',
      'khaki-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/khaki_e476c16a-be4c-4175-b172-795b03732970.jpg?v=1620318490',
      'brown-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-brown_dcce63cc-60ef-43d1-af4c-0eb8135e266d.jpg?v=1620318490',
      'black-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-black_f18dd2a3-dcda-41f8-8ea1-8abd62ec2914.jpg?v=1620318490',
      'beige-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-beige_ab9f1e74-d675-4231-9d43-4eca8b746eb1.jpg?v=1620318490',
      'grey-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-grey_c8219aca-0f59-4ffc-9eff-b313af3be567.jpg?v=1620318490',
      'blue-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-blue_200e5a88-628a-4d15-b75d-c5805bba5f3b.jpg?v=1620318491',
      'black-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-black_410a26c0-3cd4-4d69-ab81-5772a2a889c4.jpg?v=1620318490',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_mesh_Green.jpg?v=1626852862',
      'nato-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame74_1800x1800.png?v=1657291680',
      'nato-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame87_1800x1800.png?v=1657292348'
    }
  }, {
    id: 'silver-storm',
    name_pre: 'Silver',
    name: 'Storm',
    name_post: '',
    price_from: 'CHF 2,019',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_silver-storm.jpg?v=1618390430',
    variantId: 39372056658077,
    strapOptions: {
      'blue-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/blue_7ebe7013-17a5-45bb-939d-de8efbe76a80.jpg?v=1620318381',
      'black-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/black_4a028dd8-0ca7-4719-96d6-1efaa257698b.jpg?v=1620318381',
      'khaki-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/khaki_d271e902-7f86-444f-8591-e48eeb04d0f3.jpg?v=1620318381',
      'brown-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-brown_77a786ae-6e8e-424e-bc16-d020fff44969.jpg?v=1620318380',
      'black-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-black_631040dc-d457-4275-8810-0db78d450ded.jpg?v=1620318380',
      'beige-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-beige_a383b171-42bd-4419-bdc8-77843bfea728.jpg?v=1620318381',
      'grey-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-grey_4643dc37-604e-4fa9-8331-6ebb0457df10.jpg?v=1620318380',
      'blue-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-blue_73ddb88b-a685-4744-a0ab-065e251c6198.jpg?v=1620318381',
      'black-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-black_ea8c7983-b523-4189-a7cd-8cb1558ba6b7.jpg?v=1620318381',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_mesh_Silver.jpg?v=1626852862',
      'nato-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame75_1800x1800.png?v=1657291680',
      'nato-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame86_1800x1800.png?v=1657292337'
    }
  }, {
    id: 'deep-blue',
    name_pre: 'Deep',
    name: 'Blue',
    name_post: '',
    price_from: 'CHF 2,019',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_deep-blue.jpg?v=1618390430',
    variantId: 31629003784324,
    strapOptions: {
      'blue-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/blue_78bc35a8-bcd1-447c-99a2-cb3f49cee38c.jpg?v=1620318599',
      'black-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/black_31af89a4-d67a-4184-b06e-d73c3f16f04f.jpg?v=1620318599',
      'khaki-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/khaki_f87a1c97-876d-4bb9-9ca1-0b52ec642c72.jpg?v=1620318599',
      'brown-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-brown_9c1d4c7e-293d-47b3-a5ff-bb9a154844b7.jpg?v=1620318599',
      'black-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-black_32dad763-54f4-4716-bb48-2d41dbb8e12a.jpg?v=1620318599',
      'beige-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-beige_695f7dc3-5f57-4f77-82d2-eab59c0e3790.jpg?v=1620318599',
      'grey-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-grey_29957a4d-b858-466e-8d6f-4c869aef9eca.jpg?v=1620318599',
      'blue-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-blue_53045e97-2227-4d13-babe-e626de3488ab.jpg?v=1620318598',
      'black-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-black_6b5332b8-627b-4d96-952c-790b3a2870ae.jpg?v=1620318599',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_mesh_Blue.jpg?v=1626852862',
      'nato-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame73_1800x1800.png?v=1657291680',
      'nato-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame85_1800x1800.png?v=1657292340'
    }
  }, {
    id: 'gravel-black',
    name_pre: 'Gravel',
    name: 'Black',
    name_post: '',
    price_from: 'CHF 2,019',
    production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_gravel-black.jpg?v=1618390430',
    variantId: 32010659692676,
    strapOptions: {
      'blue-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/blue_b7264d3a-3ed3-4d19-9927-a75c3b13e2e8.jpg?v=1620318684',
      'black-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/black_b3c13092-475a-438b-b8fc-1a6a6993f78d.jpg?v=1620318684',
      'khaki-textile': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/khaki_74c6baaa-136a-4198-b36f-bb5e59843f00.jpg?v=1620318684',
      'brown-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-brown_b74a59c0-8407-4f44-8b66-75300c4a7ff1.jpg?v=1620318684',
      'black-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-black_150b8cc3-59ac-47e6-b20b-5e8bd770604c.jpg?v=1620318684',
      'beige-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-beige_31583bfa-bfa7-4276-8831-eb4d64f1920c.jpg?v=1620318684',
      'grey-leather': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/leather-grey_5ee11db8-5d8b-43f7-a8bb-74990089b419.jpg?v=1620318684',
      'blue-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-blue_fc7c5eda-cc00-44f0-9084-49043a4f8928.jpg?v=1620318684',
      'black-rubber': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/rubber-black_57310810-8a70-47bb-94e2-9a52f62e9b1d.jpg?v=1620318684',
      'mesh': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/archimedes_mesh_Black.jpg?v=1626852862',
      'nato-blue': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame72_1800x1800.png?v=1657291680',
      'nato-black': 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/Frame84_1800x1800.png?v=1657292343'
    }
  }]
}]

export default models;
